export enum RequestType {
  DIRECT = 'DIRECT',
  REVOKE = 'REVOKE',
  UPDATE = 'UPDATE',
  TRANSFER = 'TRANSFER',
  NEW = 'NEW'
}
